import React from 'react';
import useAboutPanels from '../custom-hooks/useAboutPanels';

function AboutPanels (props) {
  const [aboutPanels, isLoading] = useAboutPanels();
  if (isLoading === true) {
    return <p>Loading...</p>;
  }

    return (
        <div className="panelHolder" id="aboutPanelHolder">
            <div className="row">
            {aboutPanels.map((aPanel, index) => {
                const svgString = aPanel.fields.svgCode;
                let panelClass = "col-sm-6 col-lg-4 ";
                if (index === 2) {
                    panelClass += "middlePanel";
                }
      return (
            <div className={panelClass} key={aPanel.fields.title}>
                <div className="panelSvg">
                    <div className="panelIcon panelIconNoHover" 
                        dangerouslySetInnerHTML={{
                        __html: svgString,
                    }}
                    />
                </div>
                <h2 className="panelTitle">{aPanel.fields.title}</h2>
                <p className="panelText">{aPanel.fields.description}</p>
            </div>
      );
    })}
            </div>
        </div>
    );


}

export default AboutPanels;
